import {memo} from "react";
import { Link } from "react-router-dom";
import AwesomeCard from "@/components/common/awesome-card";
import CardImageZoomIn from "@/components/common/card-image-zoom-in";

const evenements = [
    {
        title: "Rallye",
        image: "/images/evenements/Rallye-BANDAMA.jpg"
    },
    {
        title: "MASSA",
        image: "/images/evenements/massa.png"
    },
    {
        title: "FEMUA",
        image: "/images/evenements/FEMUA.jpg"
    },
    {
        title: "Paquinou",
        image: "/images/evenements/Paquinou-copie-scaled.jpg"
    },
    {
        title: "Abissa",
        image: "/images/evenements/Abissa-copie.jpg"
    },
    {
        title: "Tchin Dan Festival",
        image: "/images/evenements/Tchin-Dan-Festival-copie-scaled.jpg"
    },
];

function EvenementCard() {
    return (<AwesomeCard title={"Evènements"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-2 mt-4">
            {evenements.map((evenement, index) => {
                return <Link to={"/"} key={index} className={"cursor-pointer"}>
                    <CardImageZoomIn image={evenement.image} title={evenement.title} className={"h-[200px]"} />
                </Link>
            })}
        </div>
    </AwesomeCard>)
}

export default memo(EvenementCard);